import * as React from 'react';
import { List, ListItem, ListItemText, Popover, Tooltip, Typography } from '@mui/material';
import { IB } from '../../../page/portal/setting/SettingPanel';
import { GitHub } from '@mui/icons-material';

export default function CamelGitPopover(props) {

    const { action, setCode } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'camelNotif-popover' : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const doAction = (script) => {
        if (action) action(script);
        handleClose();
    }

    return (
        <React.Fragment>
            <Tooltip title="Operações GIT">
                <IB
                    color='primary'
                    onClick={handleClick}
                    size="small"
                >
                    <GitHub />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense={true}>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => doAction('camel-js-mongo-gitClone.js')}>
                        <ListItemText
                            primary="Git Clone"
                        />
                    </ListItem>
                    
                </List>
            </Popover>
        </React.Fragment>
    )
}